module.exports = __webpack_public_path__ + "static/media/lotr.bc043b11.mp3";